window.SiteReady(($) => {

  console.log('Init Block: Header Calculator');

  let Formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', useGrouping: false });

  function formatMoney(val) {
    return Formatter
    .formatToParts(val)
    .map(({ type, value }) => {
      switch (type) {
        case "integer":
          return `<span class="count">${value}</span>`;
        default:
          return value;
      }
    })
    .join("");
  }

  let $header = $('.js-header_calc');
  let $form_fields_wrapper = $header.find('.header_calculator_form_fields_wrapper');
  let $form_results_wrapper = $header.find('.header_calculator_form_results_wrapper');

  // ORIGINAL CALCULATIONS:

  document.getElementById('js-header_cost_calculator').addEventListener('submit', function(event) {
    event.preventDefault();

    $form_fields_wrapper.toggleClass('hide');
    $form_fields_wrapper.toggleClass('show');
    $form_results_wrapper.toggleClass('hide');
    $form_results_wrapper.toggleClass('show');

    window.scrollToElement(".cost_calculator_result");
    // if ($(window).width() < 960) {
    // }

    let nameFirst = document.getElementById('name_first').value.trim();
    let nameLast = document.getElementById('name_last').value.trim();
    // let practiceAreas = document.getElementById('practice_areas').value.trim();

    let email = document.getElementById('email').value.trim();

    const fields = [
      { id: 'amount-tme', value: document.getElementById('amount-tme').value.trim() },
      { id: 'amount-vd', value: document.getElementById('amount-vd').value.trim() },
      { id: 'amount-li', value: document.getElementById('amount-li').value.trim() },
      { id: 'amount-fme', value: document.getElementById('amount-fme').value.trim() },
    ];

    let hasEmpty = false;

    fields.forEach(field => {
      const inputEl = document.getElementById(field.id);
      const wrapper = inputEl.closest('.gfield');

      if (!field.value) {
          wrapper.classList.add('gfield_error');
          hasEmpty = true;
      } else {
          wrapper.classList.remove('gfield_error');
      }
    });

    const validationContainer = document.getElementById('gform_cost_calculator_validation_container');

    const bones = document.getElementById('toggle-broken-bones');
    const surgery = document.getElementById('toggle-surgery');
    const chiro = document.getElementById('toggle-chiro');

    if (!hasEmpty) {

      if (!validationContainer.classList.contains('hidden')) {
        validationContainer.classList.add('hidden');
      }

      const calcTme = parseInt(fields[0].value.replace('$', ''));
      const calcVd = parseInt(fields[1].value.replace('$', ''));
      const calcLi = parseInt(fields[2].value.replace('$', ''));
      const calcFme = parseInt(fields[3].value.replace('$', ''));
      const calcBones = bones.checked;
      const calcSurgery = surgery.checked;
      const calcChiro = chiro.checked;

      const calcTmeMin = calcTme * 1 + (calcBones ? calcTme * 1 : 0) + (calcSurgery ? calcTme * 1.5 : 0) + 0;
      const calcTmeMax = calcTme * 3 + (calcBones ? calcTme * 1 : 0) + (calcSurgery ? calcTme * 1.5 : 0) + 0;

      const calcFmeMin = calcFme * 1 + (calcBones ? calcFme * 1 : 0) + (calcSurgery ? calcFme * 1.5 : 0) + 0;
      const calcFmeMax = calcFme * 3 + (calcBones ? calcFme * 1 : 0) + (calcSurgery ? calcFme * 1.5 : 0) + 0;

      const totalMin = calcTmeMin + calcFmeMin + calcVd + calcLi;
      const totalMax = calcTmeMax + calcFmeMax + calcVd + calcLi;

      const formattedTotalMin = formatMoney(totalMin);
      const formattedTotalMax = formatMoney(totalMax);

      $('#js-amount_min').html(formattedTotalMin);
      $('#js-amount_max').html(formattedTotalMax);

      $('.count').each(function () {
        let $this = $(this);

        $({ Counter: 0 }).animate({ Counter: $this.text() }, {
          duration: 1000,
          easing: 'linear',
          step: function (now) {
            $this.text(Math.ceil(now));
          }
        });

        setTimeout(() => {
          const newText = $this.text().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          $this.text(function() {
            return newText;
          });
        }, 1040);
      });

      //

      const checkedBones = calcBones ? bones.value : '';
      const checkedSurgery = calcSurgery ? surgery.value : '';
      const checkedChiro = calcChiro ? chiro.value : '';

      const url = window.location.href.split('/');
      const practiceArea = url.slice(url.length - 3, -1).join('/')

      let data = {
        action: 'theme_header_calculator_submit',
        nameFirst: nameFirst,
        nameLast: nameLast,
        // practiceAreas: practiceAreas,
        email: email,
        calcTme: calcTme,
        calcVd: calcVd,
        calcLi: calcLi,
        calcFme: calcFme,
        checkedBones: checkedBones,
        checkedSurgery: checkedSurgery,
        checkedChiro: checkedChiro,
        totalMin: totalMin,
        totalMax: totalMax,
        practiceArea: practiceArea,
      };

      $.ajax({
        type: 'POST',
        url: THEME_OPTIONS.ajax_url,
        data: data,
        success: (data, textStatus, jqXHR) => {
          console.log('success', data, textStatus, jqXHR);
          console.log(data.report);

          // $item.find('.js-report_container').html(data.data.report);

          // index = indexLast;

          // updateStep();

          // $item.removeClass('loading');

          // // Custom event tracking with user values
          // window.dataLayer = window.dataLayer || [];
          // window.dataLayer.push({
          //   'event': 'GFTrackEvent',
          //   'GFTrackCategory': 'form_submit',
          //   'GFTrackLabel': 'email:' + $('#calculator_email').val() + '|phone:' + $('#calculator_phone').val(),
          // });
        },
        error: (jqXHR, status, error) => {
          console.log('Error', jqXHR, status, error);

          // $item.removeClass('loading');

          // TODO handle errors
        },
      });
    } else {
      if (validationContainer.classList.contains('hidden')) {
        validationContainer.classList.remove('hidden');
      }
    }
  });
});